module.exports = __webpack_public_path__ + "img/404.1ca826d5.png";